import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ProfileEditPopup.ProfileAvatar', {
    maxSizeText: 'Max size: {maxSize}',
});
